import React, { useContext } from 'react';
import { FiList } from 'react-icons/fi';
import { FormContext } from '../../context/EquipmentFormContext';

const Step9 = () => {
  const { formData, updateField } = useContext(FormContext);

  const notes = formData.notes || '';
  const isDecommissioned = formData.decommissioned === 'Yes';

  return (
    <section className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">

      {/* Header */}
      <div className="flex items-start gap-3 mb-5">
        <div className="w-9 h-9 rounded-lg bg-blue-600 text-white flex items-center justify-center shrink-0">
          <FiList size={18} />
        </div>

        <div className="flex items-start gap-2">
          <div className="w-6 h-6 rounded-md bg-blue-50 text-blue-600 flex items-center justify-center text-sm font-bold">
            9
          </div>

          <div>
            <h3 className="text-sm font-bold text-slate-900">
              Additional Information
            </h3>

            <p className="text-[11px] text-slate-500 mt-0.5">
              Add any other relevant information.
            </p>
          </div>
        </div>
      </div>

      {/* Fields */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start">

        {/* Notes */}
        <div className="lg:col-span-4">
          <label className="block text-[11px] font-semibold text-slate-700 mb-1.5">
            Notes
          </label>

          <textarea
            rows={4}
            maxLength={500}
            value={notes}
            onChange={(e) => updateField('notes', e.target.value)}
            placeholder="e.g. key use, capacity, special instructions, supplier details, asset value etc."
            className="
              w-full
              min-h-[92px]
              resize-none
              px-3
              py-2.5
              border
              border-gray-300
              rounded-md
              text-xs
              text-slate-700
              placeholder:text-slate-400
              focus:outline-none
              focus:ring-1
              focus:ring-blue-500
              focus:border-blue-500
            "
          />

          <div className="text-right mt-1">
            <span className="text-[10px] text-slate-400">
              {notes.length}/500
            </span>
          </div>
        </div>

        {/* Decommissioned */}
        <div className="lg:col-span-2">
          <label className="block text-[11px] font-semibold text-slate-700 mb-3">
            Decommissioned?
          </label>

          <div className="flex items-center gap-5">

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="decommissioned"
                value="Yes"
                checked={formData.decommissioned === 'Yes'}
                onChange={(e) =>
                  updateField('decommissioned', e.target.value)
                }
                className="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />

              <span className="text-xs text-slate-700">
                Yes
              </span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="decommissioned"
                value="No"
                checked={formData.decommissioned === 'No'}
                onChange={(e) => {
                  updateField('decommissioned', e.target.value);
                  updateField('decommissionDate', '');
                  updateField('decommissionReason', '');
                }}
                className="w-4 h-4 text-blue-600 focus:ring-blue-500"
              />

              <span className="text-xs text-slate-700">
                No
              </span>
            </label>

          </div>
        </div>

        {/* Decommission Date */}
        <div className="lg:col-span-3">
          <label className="block text-[11px] font-semibold text-slate-700 mb-1.5">
            Decommission Date
          </label>

          <input
            type="date"
            value={formData.decommissionDate}
            onChange={(e) =>
              updateField('decommissionDate', e.target.value)
            }
            disabled={!isDecommissioned}
            className={`
              w-full
              px-3
              py-2.5
              border
              border-gray-300
              rounded-md
              text-xs
              focus:outline-none
              focus:ring-1
              focus:ring-blue-500
              focus:border-blue-500
              ${!isDecommissioned
                ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
                : 'bg-white text-slate-700'
              }
            `}
          />
        </div>

        {/* Reason */}
        <div className="lg:col-span-3">
          <label className="block text-[11px] font-semibold text-slate-700 mb-1.5">
            Reason (if decommissioned)
          </label>

          <input
            type="text"
            value={formData.decommissionReason}
            onChange={(e) =>
              updateField('decommissionReason', e.target.value)
            }
            disabled={!isDecommissioned}
            placeholder="e.g. replaced, beyond repair"
            className={`
              w-full
              px-3
              py-2.5
              border
              border-gray-300
              rounded-md
              text-xs
              placeholder:text-slate-400
              focus:outline-none
              focus:ring-1
              focus:ring-blue-500
              focus:border-blue-500
              ${!isDecommissioned
                ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
                : 'bg-white text-slate-700'
              }
            `}
          />
        </div>

      </div>

    </section>
  );
};

export default Step9;